import { logComponentError } from '@ms/yammer-data/dist/domains/diagnosticsDebugLogs/actions';
import { connect } from 'react-redux';
import ErrorBoundary from './ErrorBoundary';
export const mapDispatchToProps = (dispatch) => ({
    logComponentError: (componentName, error) => dispatch(logComponentError(componentName, error)),
});
export default connect(null, mapDispatchToProps)(ErrorBoundary);
//# sourceMappingURL=ErrorBoundaryContainer.js.map